import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { HeartToggle } from '@moonpig/launchpad-components'
import { useLocaleText } from '../../locale'

const StyledHeartToggleWrapper = styled.div`
  ${s({
    position: 'absolute',
    top: 2,
    right: 2,
    zIndex: 2,
  })}
`

export type FavouriteButtonProps = {
  isSelected: boolean
  onSelect: () => void
}

export const FavouriteButton: FC<FavouriteButtonProps> = ({
  isSelected,
  onSelect,
}) => {
  const localiseText = useLocaleText()
  return (
    <StyledHeartToggleWrapper>
      <HeartToggle
        isToggled={isSelected}
        onToggle={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          e.preventDefault()
          e.stopPropagation()
          onSelect()
        }}
        ariaLabel={
          isSelected
            ? `${localiseText('card_scene_preview.remove_from_favourites')}`
            : `${localiseText('card_scene_preview.add_to_favourites')}`
        }
      />
    </StyledHeartToggleWrapper>
  )
}
